/*
 *
 * OperationAdditionalInfo
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 01-Jul-2024
 */
import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  maskedPan: <PortalMessage id='t.app.orders.operation.info.maskedPan' defaultMessage='Masked Pan' />,
  authorizationCode: (
    <PortalMessage id='t.app.orders.operation.info.authorizationCode' defaultMessage='Authorization Code' />
  ),
  authorizationResultCode: (
    <PortalMessage id='t.app.orders.operation.info.authorizationResultCode' defaultMessage='AuthorizationResultCode' />
  ),
  description: <PortalMessage id='t.app.orders.operation.info.description' defaultMessage='Description' />,
  cardCountry: <PortalMessage id='t.app.orders.operation.info.cardCountry' defaultMessage='CardCountry' />,
  threeDS: <PortalMessage id='t.app.orders.operation.info.threeDS' defaultMessage='3DS' />,
  rrn: <PortalMessage id='t.app.orders.operation.info.rrn' defaultMessage='Rrn' />,
  reservationNumber: (
    <PortalMessage id='t.app.orders.operation.info.reservationNumber' defaultMessage='Reservation Number' />
  ),
  messageReasonCode: (
    <PortalMessage id='t.app.orders.operation.info.messageReasonCode' defaultMessage='MessageReasonCode' />
  ),
  schemaTID: <PortalMessage id='t.app.orders.operation.info.schemaTID' defaultMessage='Schema TID' />,
  status: <PortalMessage id='t.app.orders.operation.info.status' defaultMessage='Status' />,
  ruleType: <PortalMessage id='t.app.orders.operation.info.ruleType' defaultMessage='Rule Type' />,
  ruleName: <PortalMessage id='t.app.orders.operation.info.ruleName' defaultMessage='Rule Name' />,
  transactionId: <PortalMessage id='t.app.orders.operation.info.transactionId' defaultMessage='Transaction ID' />,
  invoiceId: <PortalMessage id='t.app.orders.operation.info.invoiceId' defaultMessage='Invoice ID' />,
  installmentQty: <PortalMessage id='t.app.orders.operation.info.installmentQty' defaultMessage='Number of installments' />,
  contractId: <PortalMessage id='t.app.orders.detail.subscriptionPlan.contractId' defaultMessage='Contract ID' />, 
  transactionType: <PortalMessage id='t.app.orders.operation.info.transactionType' defaultMessage='Transaction Type' />,
  transactionMode: <PortalMessage id='t.app.orders.operation.info.transactionMode' defaultMessage='Transaction Mode' />
}

export const tooltips = defineMessages({
  transactionId_tooltip: {
    id: 't.app.orders.operation.info.transactionId.Titletooltip',
    defaultMessage: 'Unique identifier of the third-party transaction, useful for reconciliation and support.'
  }
})

export const messages = defineMessages({
  APPROVED: {
    id: 't.app.orders.summary.order.status.approved',
    defaultMessage: 'Approved'
  },
  CAPTURED: {
    id: 't.app.orders.summary.order.status.captured',
    defaultMessage: 'Captured'
  }
})

export default formattedMessage
